export enum ClientStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}
